import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelDynamic as _vModelDynamic, vModelText as _vModelText, createBlock as _createBlock, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "no-tabs sent-geo-modal module-form" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "edit"
}
const _hoisted_8 = {
  key: 0,
  class: "col-12 mb-3"
}
const _hoisted_9 = {
  for: "created_at",
  class: "form-label"
}
const _hoisted_10 = {
  key: 1,
  class: "col-12 mb-3"
}
const _hoisted_11 = {
  for: "created_at",
  class: "form-label"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["for"]
const _hoisted_14 = ["type", "id", "name", "onUpdate:modelValue"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["for"]
const _hoisted_17 = ["id", "onUpdate:modelValue"]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["for"]
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  for: "field.name",
  class: "form-label check-label"
}
const _hoisted_22 = ["id", "value", "name", "onUpdate:modelValue"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = {
  key: 0,
  for: "field.name",
  class: "form-label check-label"
}
const _hoisted_26 = ["id", "value", "name", "onUpdate:modelValue"]
const _hoisted_27 = ["for"]
const _hoisted_28 = {
  key: 1,
  class: "form-check"
}
const _hoisted_29 = ["id", "name", "onUpdate:modelValue", "true-value"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { key: 5 }
const _hoisted_32 = ["for"]
const _hoisted_33 = ["type", "id", "name", "value", "onInput"]
const _hoisted_34 = { key: 6 }
const _hoisted_35 = ["value", "type"]
const _hoisted_36 = { class: "error-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('modules.forms.gps_required')) + " ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-spinner fa-spin fa-1x" }, null, -1))
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("button", {
              class: "btn btn-danger",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGPS && _ctx.onGPS(...args)))
            }, _toDisplayString(_ctx.$t('modules.forms.gps_button')), 1)
          ])
        ], 512), [
          [_vShow, _ctx.gps.lock]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, [
              (_ctx.checkParams)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('modules.forms.list.edit_head')), 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.form.name), 1)
            ])
          ]),
          (_ctx.checkParams || _ctx.checkIfAdminOrBoss())
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('modules.forms.list.user')) + ":", 1),
                _createVNode(_component_VueSelect, {
                  options: _ctx.users,
                  clearable: true,
                  "reset-on-options-change": false,
                  label: "fullName",
                  icon: "bi bi-person",
                  class: "vue-select",
                  style: {"border":"1px solid lightseagreen !important"},
                  value: _ctx.selectedUserId,
                  onUpdateSelect: _ctx.updateUserValue,
                  key: "user"
                }, null, 8, ["options", "value", "onUpdateSelect"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.checkParams || _ctx.checkIfAdminOrBoss())
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('modules.forms.list.createdAt')) + ":", 1),
                _createVNode(_component_date_picker, {
                  value: _ctx.createdAt,
                  class: "flex-grow",
                  type: 'datetime',
                  range: false,
                  onEmitDate: _ctx.updateCreatedAt,
                  style: {"border":"1px solid lightseagreen !important"},
                  required: true,
                  "show-custom-time-buttons": true
                }, null, 8, ["value", "onEmitDate"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.fields, (field, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 mb-3"
            }, [
              (_ctx.formData[index] && field.field_type.name === 'input')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("label", {
                      for: field.name,
                      class: "form-label"
                    }, _toDisplayString(field.label) + ":", 9, _hoisted_13),
                    (field.multiple === false)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: field.field_type.data_type,
                          id: field.name,
                          name: field.name,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].value) = $event),
                          class: "form-control"
                        }, null, 8, _hoisted_14)), [
                          [_vModelDynamic, _ctx.formData[index].value]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.formData[index] && field.field_type.name === 'textarea')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("label", {
                        for: field.name,
                        class: "form-label"
                      }, _toDisplayString(field.label) + ":", 9, _hoisted_16),
                      _withDirectives(_createElementVNode("textarea", {
                        id: field.name,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].value) = $event),
                        class: "form-control textarea"
                      }, null, 8, _hoisted_17), [
                        [_vModelText, _ctx.formData[index].value]
                      ])
                    ]))
                  : (_ctx.formData[index] && field.field_type.name === 'select')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("label", {
                          for: field.name,
                          class: "form-label"
                        }, _toDisplayString(field.label), 9, _hoisted_19),
                        (_openBlock(), _createBlock(_component_VueSelect, {
                          options: _ctx.getSelectOptions(field),
                          clearable: true,
                          "reset-on-options-change": false,
                          onUpdateSelect: ($event: any) => (_ctx.updateValue(field.id, $event, field.multiple)),
                          label: "label",
                          icon: "bi bi-ui-checks",
                          multiple: field.multiple,
                          value: _ctx.selectFieldValues[field.id],
                          class: "flex-grow vue-select",
                          key: field.name
                        }, null, 8, ["options", "onUpdateSelect", "multiple", "value"]))
                      ]))
                    : (_ctx.formData[index] && field.field_type.name === 'radio')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(field.label) + ":", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((field.options || []), (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option.value,
                              class: "form-check"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "radio",
                                id: `${field.name}-${option.value}`,
                                value: option.value,
                                name: field.name,
                                class: "form-check-input",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].value) = $event)
                              }, null, 8, _hoisted_22), [
                                [_vModelRadio, _ctx.formData[index].value]
                              ]),
                              _createElementVNode("label", {
                                for: `${field.name}-${option.value}`,
                                class: "form-check-label"
                              }, _toDisplayString(option.label), 9, _hoisted_23)
                            ]))
                          }), 128))
                        ]))
                      : (_ctx.formData[index] && field.field_type.name === 'checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (field.options?.length)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(field.label) + ":", 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((field.options || []), (option) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: option.value,
                                class: "form-check"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  id: `${field.name}-${option.value}`,
                                  value: option.value,
                                  name: field.name,
                                  class: "form-check-input",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].value) = $event)
                                }, null, 8, _hoisted_26), [
                                  [_vModelCheckbox, _ctx.formData[index].value]
                                ]),
                                _createElementVNode("label", {
                                  for: `${field.name}-${option.value}`,
                                  class: "form-check-label"
                                }, _toDisplayString(option.label), 9, _hoisted_27)
                              ]))
                            }), 128)),
                            (!field.options?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: field.name,
                                    name: field.name,
                                    class: "form-check-input",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.formData[index].value) = $event),
                                    "true-value": field.default_value !== '' ? field.default_value : 1,
                                    "false-value": null
                                  }, null, 8, _hoisted_29), [
                                    [_vModelCheckbox, _ctx.formData[index].value]
                                  ]),
                                  _createElementVNode("label", {
                                    for: field.name,
                                    class: "form-check-label"
                                  }, _toDisplayString(field.label), 9, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.formData[index] && field.field_type.name === 'hidden')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (this.checkParams || _ctx.checkIfAdminOrBoss())
                                ? (_openBlock(), _createElementBlock("label", {
                                    key: 0,
                                    for: field.name,
                                    class: "form-label check-label"
                                  }, _toDisplayString(field.label) + ":", 9, _hoisted_32))
                                : _createCommentVNode("", true),
                              (field.multiple === false)
                                ? (_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: (this.checkParams || _ctx.checkIfAdminOrBoss() ? 'text' : field.field_type.data_type),
                                    id: field.name,
                                    name: field.name,
                                    class: "form-control",
                                    style: {"border-color":"lightseagreen"},
                                    value: _ctx.toJson(_ctx.formData[index].value),
                                    onInput: ($event: any) => (_ctx.fromJson($event, index))
                                  }, null, 40, _hoisted_33))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.formData[index] && field.field_type.name === 'button')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary",
                                  value: field.default_value,
                                  type: field.field_type.data_type
                                }, _toDisplayString((_ctx.params ? _ctx.$t('modules.forms.list.edit') : field.label)), 9, _hoisted_35)
                              ]))
                            : _createCommentVNode("", true),
              (_ctx.v.formData?.[index]?.$errors?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(_ctx.v.formData[index].$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_36, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512), [
          [_vShow, !_ctx.gps.lock]
        ])
      ])
    ], 32)
  ]))
}